(function() {
  define('bazemont/news/delete',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsDelete', []).component('bazemontNewsDelete', {
      template: '<div class="pull-right"><a href="" ng-click="$ctrl.openModal()"><i class="fa fa-trash"></i></a></div>',
      bindings: {
        postTitle: '@',
        url: '@'
      },
      controller: [
        '$window', 'TlhConfirmModalService', function($window, TlhConfirmModalService) {
          var vm;
          vm = this;
          vm.openModal = function() {
            var message;
            message = "<p class=\"text-center\">Êtes-vous sûr(e) de vouloir supprimer l'actualité <br><strong>" + vm.postTitle + "</strong> ?</p>";
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                return $window.location.href = vm.url;
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=delete.js.map
;
